(() => {
  const reveal = () => {
    if (location.hash !== '#gpp-platter-calculator') return;
    const section = document.getElementById('gpp-platter-calculator');
    const details = section?.querySelector('details');
    if (details) { details.open = true; section.scrollIntoView({block:'start'}); }
  };
  reveal();
  window.addEventListener('hashchange', reveal);
  document.addEventListener('click', event => {
    const link = event.target.closest('a');
    if (link && new URL(link.href, location.href).hash === '#gpp-platter-calculator') setTimeout(reveal, 0);
  });
})();
